import { createAsyncThunk } from '@reduxjs/toolkit';
import { setEmiDueData, setLoading, setSearchResults, setLoadingSearch } from './emiDueSlice';
import { getDueEmisApi } from '../../../apiservice/accounts';
import { getAccountBySeachApi } from '../../../apiservice/setting';

export const fetchEmiDueList = createAsyncThunk(
    'emiDue/fetchEmiDueList',
    async (payload, { dispatch, getState }) => {
        try {
            dispatch(setLoading(true));

            const response = await getDueEmisApi({
                customerId: payload.customerId,
                dateTo: payload.dateTo,
            });

            if (response.data) {
                dispatch(setEmiDueData({ list: response.data }));

                // Get customer details if needed
                const state = getState();
                if (state.emiDue.filters.customerId) {
                    const customerResponse = await getAccountBySeachApi({
                        query: '',
                        type: 'debitor',
                        acc_id: state.emiDue.filters.customerId
                    });

                    if (customerResponse.data && customerResponse.data.length > 0) {
                        dispatch(setEmiDueData({
                            list: response.data,
                            customer: customerResponse.data[0]
                        }));
                    }
                }
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching EMI due list:', error);
            throw error;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const searchCustomers = createAsyncThunk(
    'emiDue/searchCustomers',
    async (searchTerm, { dispatch, getState }) => {
        try {
            dispatch(setLoadingSearch(true));

            const state = getState();
            const { auth: authInfo } = state;

            let accountTypes = ["Customer"];
            if (authInfo.subscription === "SuperERP" || authInfo.branch_company_type === "Pharmacy") {
                accountTypes = ["Customer", "Patient"];
            }

            const response = await getAccountBySeachApi({
                query: searchTerm.trim(),
                type: "debitor",
                acc_type_name: accountTypes,
            });

            dispatch(setSearchResults(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error searching customers:', error);
            throw error;
        } finally {
            dispatch(setLoadingSearch(false));
        }
    }
);